/*
 * @Description: 语言包能力
 * @Author: kadenwang@tencent.com
 * @Date: 2021-12-03 11:15:25
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-29 13:09:00
 */

import ar_language from './ar.json';
import de_language from './de.json';
import en_language from './en.json';
import es_language from './es.json';
import id_language from './id.json';
import ja_language from './ja.json';
import ko_language from './ko';
import pt_language from './pt.json';
import ru_language from './ru.json';
import th_language from './th.json';
import tr_language from './tr.json';
import ur_language from './ur.json';
import vi_language from './vi.json';
import zh_CN_language from './zh_CN.json';
import zh_HK_language from './zh_HK.json';
import zh_TW_language from './zh_TW.json';

export enum ILanguage {
  zh_CN = 'zh_CN',
  en = 'en',
  de = 'de',
  id = 'id',
  es = 'es',
  pt = 'pt',
  // tr = 'tr',
  ja = 'ja',
  ru = 'ru',
  th = 'th',
  vi = 'vi',
  zh_TW = 'zh_TW',
  ko = 'ko',
  ar = 'ar',
  zh_HK = 'zh_HK',
  ur = 'ur',
  tr = 'tr'
}

const allLanguageData = {
  zh_CN: zh_CN_language,
  en: en_language,
  de: de_language,
  id: id_language,
  es: es_language,
  pt: pt_language,
  ja: ja_language,
  ru: ru_language,
  th: th_language,
  vi: vi_language,
  zh_TW: zh_TW_language,
  ko: ko_language,
  ar: ar_language,
  zh_HK: zh_HK_language,
  ur: ur_language,
  tr: tr_language,
};


class I18n {
  private languageInfo: Record<string, string> = allLanguageData.en;

  public async initI18n(language: ILanguage) {
    if (Object.values(ILanguage).includes(language)) {
      this.languageInfo = allLanguageData[language];
    }
  }

  public l(key: string) {
    return this.languageInfo[key];
  }
}

export default new I18n();
